import api from "./api";

const BASE = "/package";

export const scanPackage = async (trackingNumber) =>
    (await api.post(`${BASE}/scan`, { trackingNumber })).data;

export default {
    scanPackage,
};